export default "__VITE_ASSET__CF7KjMrW__"